import { useSelector } from 'react-redux';
import { getPrePostNpsCsatSummary } from 'redux/selectors/analytics';
import { NpsCsatSummary } from 'redux/schemas/app/analytics';
import NpsCsat from '../nps-csat-stats/nps-csat';

const PrePostNpsCsatPanel = () => {
  const npsCsatSummary = useSelector(getPrePostNpsCsatSummary) as NpsCsatSummary | null | undefined;
  if (!npsCsatSummary) return null;
  return (
    <div className='pre-post-nps-csat-panel'>
      <NpsCsat npsCsatSummary={npsCsatSummary} />
    </div>
  );
};

export default PrePostNpsCsatPanel;
